import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store';
import routes from './core/index';

import * as perimeters from '../configs/Perimeters';
import RouteGoverness from '../helpers/RouteGoverness';
import { createSandbox } from 'vue-kindergarten';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
    linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
    let nonAuthRoutes = ['login', 'error', 'forgot-password', 'reset-password', 'order-campaign-report'];

    if (!store.getters.isLoggedIn && !nonAuthRoutes.includes(to.name)) {
        next({ path: '/login' });
        return;
    }


    if (store.getters.isLoggedIn && store.state.user && store.state.user.client) {
        let host = window.location.host;
        let parts1 = host.substring(0, host.indexOf('.'));
        let parts2 = host.substring(host.indexOf('.'), host.length);
        if (host !== 'acq.staging.thetodaybusiness.com.au' && (parts1 !== store.state.user.client) && parts2.indexOf('localhost') <0) {
            const href = window.location.href
            const restOfUrl = href.substring(href.indexOf('.'), href.length);
            let url = "http://" + store.state.user.client + restOfUrl;
            window.location.href = url;
        }
    }
    const perimeter = perimeters[`${to.meta.resource}Perimeter`];

    if (typeof perimeter !== 'undefined') {
        const sandbox = createSandbox((store), {
            perimeters: [
                perimeter
            ],
            governess: new RouteGoverness(from, to, next)
        });

        return sandbox.guard(to.meta.action);
    }

    next();
});

export default router;
